__turbopack_context__.v({
  "Arrow": "index-module___M5-Vq__Arrow",
  "Image": "index-module___M5-Vq__Image",
  "Link": "index-module___M5-Vq__Link",
  "Paragraph": "index-module___M5-Vq__Paragraph",
  "Popup": "index-module___M5-Vq__Popup",
  "PopupContent": "index-module___M5-Vq__PopupContent",
  "Positioner": "index-module___M5-Vq__Positioner",
  "Summary": "index-module___M5-Vq__Summary",
  "Viewport": "index-module___M5-Vq__Viewport",
});
